export const borderRadius = {
  xs: '5px',
  s: '10px',
  m: '15px',
  round: '50%',
};
